import { wrapperBuilder } from './build';
import { UserService } from './common';

wrapperBuilder
  .getStaticsGeneratorsRegisterInstance()
  .addStaticProp('defineUserGetterMethod', getter => {
    UserService.instance.getter = getter;
  });
